export default __webpack_public_path__ + "static/media/iconChannelPhone.c06c8c78.svg";